module.exports = __webpack_public_path__ + "img/loading3.e44ba4a9.png";